import { FC } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";

import theme from "theme";
import { Theme } from "theme";

const useStyles = makeStyles<Theme, { isModal: boolean }>(() => ({
  container: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
  },
  label: {
    fontWeight: theme.typography.fontWeightBold,
  },
  value: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: props => (props.isModal ? "3.1rem" : "3.5rem"),
    [theme.breakpoints.down("md")]: {
      fontSize: () => "3.2rem",
    },
  },
  secondaryValue: {
    fontWeight: theme.typography.fontWeightLight,
    fontSize: "1.2rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem",
    },
  },
  fontWeightRegular: {
    fontWeight: theme.typography.fontWeightRegular,
  },
}));
const LabelValue: FC<{
  label: string;
  value: string;
  secondaryValue?: string;
  isModal: boolean;
}> = ({ label, value: amount, secondaryValue, isModal }) => {
  const classes = useStyles({ isModal });

  return (
    <Box className={classes.container}>
      <Typography variant="h5" className={classes.label}>
        {label}
      </Typography>
      <Box
        className={`${classes.value} ${
          !amount ? classes.fontWeightRegular : ""
        }`}
      >
        {amount}
      </Box>
      {secondaryValue && (
        <Box className={classes.secondaryValue}>{secondaryValue}</Box>
      )}
    </Box>
  );
};

export default LabelValue;
